const initialState = {
  deleting: false,
};

const del = (state = initialState, action) => {
  switch (action.type) {
    case 'DELETE_AUTHORIZATION_USER_REQUEST':
    case 'DELETE_AUTHORIZATION_GROUP_REQUEST':
      return {
        ...state,
        deleting: true,
      };

    case 'DELETE_AUTHORIZATION_USER_SUCCESS':
    case 'DELETE_AUTHORIZATION_GROUP_SUCCESS':
      return initialState;

    case 'DELETE_AUTHORIZATION_USER_FAILURE':
    case 'DELETE_AUTHORIZATION_GROUP_FAILURE':
      return {
        ...state,
        deleting: false,
      };

    default:
      return state;
  }
};

export default del;

export const isDeleting = (state) => state.deleting;
